/** @jsxImportSource @emotion/react */
import type { MapLayer } from '@app/types/layerTypes'
import { Box } from '@mui/material'
import { layerDetailsContainer } from './LayerInfoAccordions.styles'
import { LayerDetailsReport } from '../../../../data_fetchers/layerDetailsFetcher'
import { EmptySection } from '../../../../components/EmptySection'
import { ElementFilterForm } from '@app/components/Molecules/LayersControl/ElementFilterForm/ElementFilterForm'
import { LayerInfo } from './LayerInfo/LayerInfo'
import { useFeatureFlags } from '@app/hooks/useFeatureFlags'
import { FEATURE_FLAGS } from '@app/app-constants'

interface InfoAccordionsProps {
  layer: MapLayer
  layerType: string
  defaultExpanded?: boolean
  layerDetails: LayerDetailsReport[] | null
}

export const LayerInfoAccordions = ({ layer, layerDetails }: InfoAccordionsProps) => {
  const { useFeatureFlag } = useFeatureFlags()
  const isAttributeFiltersFeatureActive = useFeatureFlag(FEATURE_FLAGS.ATTRIBUTE_FILTERS)

  if (!layerDetails && !layer.filterable_information)
    return (
      <EmptySection
        title={`Currently there's no additional information for ${layer.display_name}`}
      />
    )

  return (
    <Box css={layerDetailsContainer()}>
      {isAttributeFiltersFeatureActive && <ElementFilterForm layer={layer} />}
      <LayerInfo layerDetails={layerDetails} />
    </Box>
  )
}
